import { RadialBar, RadialBarChart, ResponsiveContainer } from 'recharts'
import { useWidgetDensity } from '../grid/WidgetDensityContext'
import { ChartAccessibleTable, ChartFrame } from './ChartFrame'

export interface GaugeTileProps {
  title: string
  /** 0-100. */
  percent: number
  caption?: string
  height?: number
}

/**
 * AC4 — Readiness. Not exercised by real data this story (no
 * `evidence.api` readiness read port yet — `ReadinessComingSoonWidget`
 * renders the honest "coming soon" state instead of calling this), but
 * shipped as a real, generic wrapper so the fast-follow (IB-146) only needs
 * to wire data, not build a chart type.
 */
export function GaugeTile({ title, percent, caption, height = 200 }: GaugeTileProps) {
  const { density } = useWidgetDensity()
  const clamped = Math.max(0, Math.min(100, percent))
  const data = [{ key: 'readiness', value: clamped, fill: 'var(--iw-chart-1)' }]

  const table = (
    <ChartAccessibleTable
      caption={`${title} — value`}
      columns={[{ key: 'label', label: 'Metric' }, { key: 'value', label: 'Value', align: 'end' }]}
      rows={[{ label: title, value: `${clamped}%` }]}
    />
  )

  return (
    <ChartFrame
      title={title}
      height={height}
      table={table}
      chart={
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
          <ResponsiveContainer width="100%" height="100%">
            <RadialBarChart
              innerRadius="70%"
              outerRadius="100%"
              barSize={16}
              data={data}
              startAngle={90}
              endAngle={-270}
            >
              <RadialBar dataKey="value" background={{ fill: 'var(--iw-neutral-100)' }} cornerRadius={8} />
            </RadialBarChart>
          </ResponsiveContainer>
          <div
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span className="iw-kpi-value">{clamped}%</span>
            {density !== 'micro' && caption ? (
              <span style={{ fontSize: 'var(--iw-size-sm)', color: 'var(--iw-text-muted)' }}>{caption}</span>
            ) : null}
          </div>
        </div>
      }
    />
  )
}
